import { render, staticRenderFns } from "./EmployeesTab.vue?vue&type=template&id=125ce862&scoped=true"
import script from "./EmployeesTab.vue?vue&type=script&lang=js"
export * from "./EmployeesTab.vue?vue&type=script&lang=js"
import style0 from "./EmployeesTab.vue?vue&type=style&index=0&id=125ce862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125ce862",
  null
  
)

export default component.exports